import React from 'react';
import styles from './AppInputLabel.module.css';

interface AppInputLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  compact?: boolean;
  className?: string;
}

const RequiredAsterisk: React.FC = () => (
  <span className={styles.required}>*</span>
);

export const withRequiredAsterisk = (content: React.ReactNode, required = false): React.ReactNode => {
  if (!required) {
    return content;
  }

  if (typeof content !== 'string') {
    return (
      <>
        {content}
        {'\u00a0'}
        <RequiredAsterisk />
      </>
    );
  }

  const text = content.trimEnd();
  const lastSpace = text.lastIndexOf(' ');
  const head = lastSpace >= 0 ? text.slice(0, lastSpace + 1) : '';
  const tail = lastSpace >= 0 ? text.slice(lastSpace + 1) : text;

  return (
    <>
      {head}
      <span className={styles.lastChunk}>
        {tail}
        {'\u00a0'}
        <RequiredAsterisk />
      </span>
    </>
  );
};

const AppInputLabel: React.FC<AppInputLabelProps> = ({
  htmlFor,
  children,
  required = false,
  compact = false,
  className = '',
}) => (
  <label
    htmlFor={htmlFor}
    className={[styles.label, compact ? styles.compact : '', className].filter(Boolean).join(' ')}
  >
    {withRequiredAsterisk(children, required)}
  </label>
);

export default AppInputLabel;
